import React, { RefObject } from 'react'
import { Grid, Tab } from 'semantic-ui-react'

import { translate } from 'loankeeper-common/helpers'
import { GridContainer } from '../../shared/StyledComponents'
import FormField, { FormLayout } from '../../shared/newFormElements'

import DebitAccountField from '../shared/DebitAccountField'
import DebitTitle from '../shared/DebitTitle'
import CreditAccountField from '../shared/CreditAccountField'
import CreditTitle from '../shared/CreditTitle'
import PrintOptions from '../shared/PrintOptions'
import DebitAccountDetailsTrigger from '../shared/DebitAccountDetailsTrigger'
import CreditAccountDetailsTrigger from '../shared/CreditAccountDetailsTrigger'
import DebitBalance from '../shared/DebitBalance'
import CreditBalance from '../shared/CreditBalance'
import DebitAccountAddButton from '../shared/DebitAccountAddButton'
import CreditAccountAddButton from '../shared/CreditAccountAddButton'
import CCYField from '../shared/CCYField'

import SearchAccountsButton from '../components/SearchAccountsButton'
import CommentsModal from '../CommentsModal'

import {
  CHECK_DEBIT_ACCOUNT_FETCHER_NAME,
  GET_DEBIT_ACCOUNT_VIEW_FETCHER_NAME,
  CHECK_CREDIT_ACCOUNT_FETCHER_NAME,
  GET_CREDIT_ACCOUNT_VIEW_FETCHER_NAME,
} from './constants'

import mainTabContainers from './mainTabContainers'
import { MainTabProps } from './CashInOut.types'

class MainTab extends React.Component<MainTabProps> {
  handleOpCodeChange = (selected: number) => {
    this.props.change('Comment', this.props.OpCodes.find((code) => code.ID === selected).Destination)
  }
  debitAccountSearchButtonRef: RefObject<any>
  creditAccountSearchButtonRef: RefObject<any>

  render() {
    const { CCY = [], OpCodes = [], ID, hash, change, cashOut = false, form, disableInputs, AddAccount } = this.props
    return (
      <Tab.Pane>
        <GridContainer>
          <Grid>
            <Grid.Row>
              <Grid.Column width={2} textAlign="right" verticalAlign="middle">
                {translate('frm_acc_entry_add-lbl_docno')}
              </Grid.Column>

              <Grid.Column width={2}>
                {/* @ts-ignore */}
                <FormField autoFocus name="DocNo" disabled={disableInputs} />
              </Grid.Column>

              <Grid.Column width={2} textAlign="right" verticalAlign="middle">
                {translate('frm_acc_entry_add-lbl_iso')}
              </Grid.Column>

              <Grid.Column width={2}>
                <CCYField
                  name="CCY"
                  debit
                  credit
                  disabled={disableInputs}
                  onChange={this.props.handleCCYChange}
                  FormName={form}
                  //@ts-ignore
                  ccy={CCY}
                />
              </Grid.Column>

              <Grid.Column width={2} textAlign="right" verticalAlign="middle">
                {translate('frm_acc_entry_add-lbl_entrydate')}
              </Grid.Column>

              <Grid.Column width={2}>
                {/* @ts-ignore */}
                <FormLayout>
                  {/* @ts-ignore */}
                  <FormField type="date" disabled={disableInputs} name="DocDate" checkvalidity />
                </FormLayout>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </GridContainer>

        <hr />

        <GridContainer>
          <Grid>
            <Grid.Row>
              <Grid.Column width={2} textAlign="right" verticalAlign="middle">
                {translate('frm_acc_entry_add-lbl_debit')}
              </Grid.Column>

              <Grid.Column width={2} verticalAlign="middle">
                <DebitAccountField
                  disabled={!cashOut || disableInputs}
                  FormName={form}
                  searchAccountsFetcherName={CHECK_DEBIT_ACCOUNT_FETCHER_NAME}
                  debitAccountSearchButtonRef={this.debitAccountSearchButtonRef}
                  isRequired
                />
              </Grid.Column>

              <div className="u-flexCenter">
                <SearchAccountsButton
                  innerRef={(ref) => {
                    this.debitAccountSearchButtonRef = ref
                  }}
                  disabled={!cashOut || disableInputs}
                  FormName={form}
                  modalName="SearchDebitAccounts"
                  accNo="DebitAccNo"
                  titleUNI="DebitTitleUNI"
                  accID="DebitAccID"
                  accHash="DebitAccHash"
                  accBalance="DebitAccBalance"
                  chosenAccNo="DebitChosenAccNo"
                  page="searchprefix"
                />

                <DebitAccountDetailsTrigger FormName={form} />

                <DebitAccountAddButton
                  chooseClient={cashOut}
                  disabled={disableInputs || !AddAccount}
                  FormName={form}
                  fetcherName={GET_DEBIT_ACCOUNT_VIEW_FETCHER_NAME}
                />
              </div>

              <Grid.Column width={8} textAlign="center" verticalAlign="middle">
                <DebitTitle FormName={form} />
              </Grid.Column>

              <Grid.Column verticalAlign="middle" className="u-fluid">
                <DebitBalance FormName={form} />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </GridContainer>

        <hr />

        <GridContainer>
          <Grid>
            <Grid.Row>
              <Grid.Column width={2} textAlign="right" verticalAlign="middle">
                {translate('frm_acc_entry_add-lbl_credit')}
              </Grid.Column>

              <Grid.Column width={2} verticalAlign="middle">
                <CreditAccountField
                  disabled={cashOut || disableInputs}
                  FormName={form}
                  searchAccountsFetcherName={CHECK_CREDIT_ACCOUNT_FETCHER_NAME}
                  creditAccountSearchButtonRef={this.creditAccountSearchButtonRef}
                  isRequired
                />
              </Grid.Column>

              <div className="u-flexCenter">
                <SearchAccountsButton
                  innerRef={(ref) => {
                    this.creditAccountSearchButtonRef = ref
                  }}
                  disabled={cashOut || disableInputs}
                  FormName={form}
                  modalName="SearchCreditAccounts"
                  accNo="CreditAccNo"
                  titleUNI="CreditTitleUNI"
                  accID="CreditAccID"
                  accHash="CreditAccHash"
                  accBalance="CreditAccBalance"
                  chosenAccNo="CreditChosenAccNo"
                  page="searchprefix"
                />

                <CreditAccountDetailsTrigger FormName={form} />
                <CreditAccountAddButton
                  chooseClient={!cashOut}
                  disabled={disableInputs || !AddAccount}
                  FormName={form}
                  fetcherName={GET_CREDIT_ACCOUNT_VIEW_FETCHER_NAME}
                />
              </div>

              <Grid.Column width={8} textAlign="center" verticalAlign="middle">
                <CreditTitle FormName={form} />
              </Grid.Column>

              <Grid.Column verticalAlign="middle" className="u-fluid">
                <CreditBalance FormName={form} />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </GridContainer>

        <hr />

        <GridContainer>
          <Grid>
            <Grid.Row>
              <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                {translate('frm_acc_entry_add-lbl_amount')}
              </Grid.Column>

              <Grid.Column width={2}>
                {/* @ts-ignore */}
                <FormField name="Amount" type="float" autoComplete="off" disabled={disableInputs} format required />
              </Grid.Column>

              <Grid.Column width={3} />
            </Grid.Row>
          </Grid>
        </GridContainer>

        <hr />

        <GridContainer>
          <Grid>
            <Grid.Row>
              <Grid.Column width={8} />

              <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                {translate('frm_acc_entry_add-lbl_opcode')}
              </Grid.Column>

              <Grid.Column width={6}>
                {/* @ts-ignore */}
                <FormField
                  disabled={disableInputs}
                  name="OpCodeID"
                  customOnChange={this.handleOpCodeChange}
                  type="select"
                  options={OpCodes}
                  search
                />
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                {translate('frm_acc_entry_add-lbl_purpose')}
              </Grid.Column>

              <Grid.Column className="u-fluid">
                {/* @ts-ignore */}
                <FormField disabled={disableInputs} name="Comment" maxLength="300" />
              </Grid.Column>

              <CommentsModal
                disabled={disableInputs}
                OperTypeID={cashOut ? 4 : 3}
                onRowChoose={(row) => change('Comment', row.Title)}
                style={{}}
              />
            </Grid.Row>
          </Grid>
        </GridContainer>

        <hr />

        <PrintOptions FormName={form} change={change} ID={ID} hash={hash} OperTypeID={cashOut ? 4 : 3} />
      </Tab.Pane>
    )
  }
}

export default mainTabContainers(MainTab)
